import { generateTypes } from 'reducers/utils/HttpReducerHelper';

const updateSearchManager = generateTypes('FUNDING_SEARCH', 'UPDATE_SEARCH_MANAGER');

export { updateSearchManager };
